import React from 'react';
import './NameCell.less';
import LoadingCell from '../LoadingCell';
import Highlighter from 'react-highlight-words';

import { Typography } from 'antd';

const { Text } = Typography;

import { escapeRegex } from '../../../../../../shared/utils';

export default ({ loading, getIcon }) =>
  (cellProps) => {
    if (loading) {
      return <LoadingCell />;
    }

    const isSearchApplied = cellProps.dataKey === 'name' && cellProps.rowData.searchString && cellProps.rowData.searchString.length > 0;

    let cellData = isSearchApplied ? (
      <Highlighter
        highlightClassName="highlighted-text"
        searchWords={[escapeRegex(cellProps.rowData.searchString)]}
        caseSensitive={false}
        textToHighlight={cellProps.cellData}
      />
    ) : (
      cellProps.cellData || ''
    );

    if (cellProps.rowData.shared) {
      cellData = `${cellData} (Shared)`;
    }

    const { icon, color } = getIcon(cellProps.rowData);

    return (
      <div className="oc-fm--name-cell">
        <div className="oc-fm--name-cell__icon" style={{ color: color }}>
          {icon}
        </div>
        <div className="oc-fm--name-cell__title">
          <Text title={cellProps.cellData ?? ''}>{cellData}</Text>
          {cellProps.rowData.path && (
            <div className="path" title={cellProps.rowData.path}>
              {cellProps.rowData.path}
            </div>
          )}
        </div>
      </div>
    );
  };
